// extracted by mini-css-extract-plugin
export default {"transactiontype-modal":"transactiontype-modal","body-container":"body-container","change-btn":"change-btn","header-txt":"header-txt"};